class CountryRedirect extends HTMLElement {

  constructor() {
    super();

    this.popup = this;
    this.popupExpires = parseInt(this.dataset.expires);
    this.popupTestModeEnabled = typeof(this.popupExpires) === 'number' && this.popupExpires === 0;
    this.popupCookie = this.getCookie('redirect_popup');

    // if popupExpires is set to 0 (test mode), remove cookie
    if (this.popupTestModeEnabled) {
      this.removeCookie('redirect_popup');
    }

    // don't show popup when cookie is set and test mode is off
    if (this.popupCookie && this.popupCookie == 'true' && !this.popupTestModeEnabled) {
      return;
    }

    // build extreme lookup url and render popup
    if (typeof this.popup.dataset.countryRedirect !== 'undefined') {
      this.url = 'https://extreme-ip-lookup.com/json/?key=' + this.popup.dataset.countryRedirect;
      this.closeButtons = document.querySelectorAll('[data-country-redirect-close]');
      this.closeButtons.forEach(trigger =>
        trigger.addEventListener('click', this.closePopup.bind(this))
      );
      this.renderPopup();
    }
  }

  /**
   * closePopup
   * @description Close popup
   */
   closePopup () {
    this.popup.classList.add('hidden');
  }

  /**
   * openPopup
   * @description Open popup
   */
   openPopup (popupInnerContent) {
    if (!popupInnerContent) {
      return false;
    }

    this.popup.classList.remove("hidden");
    popupInnerContent.classList.remove("hidden");
  }

  /**
   * getCookie
   * @description Get cookie
   */
  getCookie (name) {
    let value = `; ${document.cookie}`;
    let parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
  }

  /**
   * removeCookie
   * @description Remove cookie
   */
  removeCookie (name) {
    if (!name) return false;
    document.cookie = `${name}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC;`;
  }

  /**
   * setCookie
   * @description Get cookie
   */
  setCookie(days) {
    if (typeof(days) !== 'number') return false;

    let maxAge = days * 60 * 60 * 24;
    if (days === 0) {
      maxAge = 0;
    }

    document.cookie = `redirect_popup=true; path=/; max-age=${ maxAge };`;
  }

  /**
   * Render popup
   * @description Render popup
   */
  renderPopup() {
    fetch(this.url)
      .then((response) => response.text())
      .then((responseText) => {

        // get ip data from ip extreme lookup
        const data = JSON.parse(responseText);
        const {countryCode, continent} = data;
        const countryCodeHandleized = countryCode.replace(/\s+/g, '-').toLowerCase();
        const continentHandleized = continent.replace(/\s+/g, '-').toLowerCase();

        // get language from browser
        let language = 'not-de';
        if (navigator.language.includes('de')) {
          language = 'de';
        }

        // get popup content for each type
        const popupContentCountry = this.popup.querySelector(`[data-country-redirect-country="${countryCodeHandleized}"]`) || false;
        const popupContentContinent = this.popup.querySelector(`[data-country-redirect-continent="${continentHandleized}"]`) || false;
        const popupContentLanguage = this.popup.querySelector(`[data-country-redirect-language="${language}"]`) || false;

        // excluded countryCodes
        const excludedCountries = popupContentLanguage.dataset.excludedCountries || false;

        // render country popup
        if (popupContentCountry !== false) {
          this.builtPopup(countryCode, popupContentCountry);

        // render continent popup
        } else if (popupContentContinent !== false) {
          this.builtPopup(continent, popupContentContinent);

        // render language popup
        } else if (popupContentLanguage !== false) {

          // don't render language popup if country is excluded
          if (excludedCountries) {
            const excludedCountriesArr = excludedCountries.split(',');
            if (excludedCountriesArr.includes(countryCode)) return;
          }

          this.builtPopup(language, popupContentLanguage);
        }

      })
      .catch(function (errors) {
        console.log("errors", errors);
      });
  }

  /**
   * Render popup title
   * @description Render popup title
   */
  renderPopupTitle(data, popup) {
    if (!data || !popup) {
      return false;
    }
    const popupTitle = popup.querySelector('[data-country-redirect-heading]') || false;
    if (popupTitle) {
      const newString = popupTitle.textContent.replace('[data]', data);
      popupTitle.textContent = newString;
    }
  }

  /**
   * builtPopup
   * @description Built popup
   */
  builtPopup(data, popup) {
    if (!data || !popup) {
      return false;
    }
    this.setCookie(this.popupExpires);
    this.renderPopupTitle(data, popup);
    this.openPopup(popup);
    this.renderPopupSubmitButtonUrl(popup);
    this.languageSwitcherClickHandler(popup);
  }

  /**
   * renderPopupSubmitButtonUrl
   * @description Redirect to the same counterpart on the other store (when on product page, collection page, etc.)
   */
  renderPopupSubmitButtonUrl(popup, url) {

    if (!popup) {
      return false;
    }

    // get submit button href
    const submitButton = popup.querySelector('[data-country-redirect-url]') || false;
    if (!submitButton) return false;
    let submitButtonUrl = submitButton.href;

    // get counterPartUrl based on button url by default
    let counterPartUrlFromSubmit = submitButtonUrl ? this.getCounterPartUrl(submitButtonUrl) : false;
    if (counterPartUrlFromSubmit !== false) submitButtonUrl = counterPartUrlFromSubmit;

    // if there is an url added in parameter, get counterPartUrl from the url given
    if (typeof url !== "undefined") {
      let counterPartUrlFromGivenUrl = this.getCounterPartUrl(url);
      submitButtonUrl = counterPartUrlFromGivenUrl || url;
    }

    // add search
    submitButtonUrl = submitButtonUrl + location.search;
    submitButton.href = submitButtonUrl;
  }

  /**
   * removeProtocol
   * @description Remove http or https from url
   */
  removeProtocol(url) {
    const domain = (new URL(url));
    if (!domain.host) return false;

    // check if there's a language in the url that matches the available languages in the current website
    const firstUrlPath = domain.pathname.split('/')[1];

    const availableLanguagesCurrentWebsite = document.querySelector('[data-country-popup-language-switcher-current]').dataset.countryPopupLanguageSwitcherCurrent;
    const availableLanguages = availableLanguagesCurrentWebsite.split(',');

    const languageInUrl = availableLanguages.find(language => language == firstUrlPath);

    // return the url with/without the language
    return languageInUrl ? `${domain.host}/${languageInUrl}` : domain.host;
  }

 /**
   * GetCounterPartUrl
   * @description
   * When country popup shows on a page that is not the homepage, like a PDP or collection page, the submit button should be redirected to that counterpart of the linked store.
   * We use the rendered alternate links from the Multi Store Hreflang Tags app to find the right counter part.
   */
  getCounterPartUrl(submitButtonUrl) {

    // Get stores, which is coming from theme settings.
    const stores = this.popup.dataset.stores || false;

    // Find the store to link to. Store item contains the primary domain and myshopify domain.
    // The reason why we need to find the domain and shopify domain is because  Multi Store Hreflang sometimes outputs the primary domain and sometimes the myshopify domain.
    const storesArray = stores?.split(',');
    if (storesArray.length === 0) return false;

    let storeToLinkTo = null;
    let url = submitButtonUrl ? this.removeProtocol(submitButtonUrl) : false;
    storesArray.forEach(function(store){
      let storeArr = store.split('|');

      const storeUrlMatch = storeArr.find(storeUrl => storeUrl == url);
      if (storeUrlMatch) {
        storeToLinkTo = storeUrlMatch;
      }
    });

    // loop through alternate links rendered by Multi Store Hreflang Tags app.
    const alternateLinksArray = [...document.querySelectorAll('link[rel="alternate"]')];
    if (alternateLinksArray.length === 0) return false;

    // get matching link and return value
    const alternateLinkHrefs = alternateLinksArray
      .filter(link => link.hasAttribute('hreflang'))
      .map(link => link.href);
    const counterPartLink = alternateLinkHrefs?.find(href => href.indexOf(`https://${storeToLinkTo}`) > -1) || null;

    return counterPartLink || false;

  }

  /**
   * languageSwitcherClickHandler
   * @description Handle click on store switcher within the country popup
   */
  languageSwitcherClickHandler(popup) {

    // when language switcher dropdown is opened
    const trigger = popup.querySelector('[data-country-popup-language-switcher-current]');
    trigger.addEventListener('click', (e) => {
      e.preventDefault();

      // check if we have dropdown options
      const dropdownOptions = [...popup.querySelectorAll('[data-country-popup-language-switcher-item]')];
      if (dropdownOptions.length === 0) {
        return false;
      }

      dropdownOptions.forEach(item => {

        // check which dropdown option has been clicked
        item.addEventListener('click', (e) => {
          e.preventDefault();

          if (!e.target.href) {
            return false;
          }

          // if we have a href, render the submit button url
          this.renderPopupSubmitButtonUrl(popup, e.target.href);

          // handle state of the dropdown
          const dropdownWrapper = popup.querySelector('[data-country-popup-language-switcher]') || false;
          const dropdownCurrent = popup.querySelector('[data-country-popup-language-switcher-current-inner]') || false;
          const dropdownHTML = e.target.innerHTML || false;

          // close dropdown
          if (dropdownWrapper) {
            dropdownWrapper.classList.remove('collapsible-is-open');
          }

          // set active item
          if (dropdownCurrent && dropdownHTML) {
            dropdownCurrent.innerHTML = dropdownHTML;
          }

        });
      });

    });

  }
}

if (!customElements.get('country-redirect')) {
  customElements.define('country-redirect', CountryRedirect);
}
